import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  ScrollArea,
  Text,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconCheck,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconTrademark,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import Avvvatars from "avvvatars-react";

const PriceListUpdateHistory = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [dataItem, setDataItem] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const sizeGrid = { base: 12, sm: 12, md: 6, lg: 2, xl: 2 };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  //search
  const [keySearch, setKeySearch] = useDebouncedState("", 500);
  const [search, setSearch] = useState<any>({
    FromDate: new Date(
      new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    ToDate: new Date(
      new Date(new Date(new Date()).setHours(0, 0, 0, 0)).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    DsMaHangSx: [],
  });
  const [searchItem, setSearchItem] = useState("");
  const [debouncedItemCode] = useDebouncedValue(searchItem, 500);
  const [searchCatSegment3c, setSearchCatSegment3c] = useState("");
  const [debouncedCatSegment3c] = useDebouncedValue(searchCatSegment3c, 500);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState("");
  const [debouncedCatSegment4d] = useDebouncedValue(searchCatSegment4d, 500);
  const [searchCatSegment5e, setSearchCatSegment5e] = useState("");
  const [debouncedCatSegment5e] = useDebouncedValue(searchCatSegment5e, 500);
  const [searchCatSegment6f, setSearchCatSegment6f] = useState("");
  const [debouncedCatSegment6f] = useDebouncedValue(searchCatSegment6f, 500);
  //Loại
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment3cFirst, setDataCatSegment3cFirst] = useState<
    ComboboxItem[]
  >([]);
  //Chủng
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  //Nhóm
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);
  //Model
  const [dataCatSegment6f, setDataCatSegment6f] = useState<ComboboxItem[]>([]);
  //Brand
  const [dataBrand, setDataBrand] = useState<ComboboxItem[]>([]);

  const [isCallFirst, setIsCallFirst] = useState(false);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maGb",
        header: "Mã bảng giá",
        Cell: ({ renderedCellValue }) => (
          <Badge
            variant="dot"
            radius="xs"
            style={{
              cursor: "pointer",
            }}
            size="md"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "trangThai",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge color={getColorStatus(renderedCellValue || 0)}>
              {renderedCellValue === 1
                ? "Đồng ý duyệt"
                : renderedCellValue === 2
                  ? "Từ chối duyệt"
                  : "Chưa duyệt"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ngayHieuLuc",
        header: "Ngày hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayHetHieuLuc",
        header: "Ngày hết hạn",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayCapNhat",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "nguoiCapNhat",
        header: "Người cập nhật",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500} size="xs">
                {row.original.maNguoiCapNhat} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            variant="dot"
            radius="xs"
            style={{
              cursor: "pointer",
            }}
            size="md"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 400,
      },
      {
        accessorKey: "listPrice",
        header: "Giá bán lẻ",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "webPrice",
        header: "Giá Build PC kèm VGA",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
        size: 225,
      },
      {
        accessorKey: "giaBuildPcKoVga",
        header: "Giá Build PC",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 225,
      },
      {
        accessorKey: "wholesalePrice1",
        header: "Giá bán buôn 1",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "wholesalePrice2",
        header: "Giá bán buôn 2",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "wholesalePrice3",
        header: "Giá bán buôn 3",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "tyLe1",
        header: "Tỷ lệ giảm giá 1",
      },
      {
        accessorKey: "tyLe2",
        header: "Tỷ lệ giảm giá 2",
      },
      {
        accessorKey: "tyLe3",
        header: "Tỷ lệ giảm giá 3",
      },
      {
        accessorKey: "giaNhap",
        header: "Giá nhập",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "lng",
        header: "LNG",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "giaNhapTamTinh",
        header: "Giá nhập tạm tính",
        // Cell: ({ renderedCellValue }) =>
        //   renderedCellValue || Number(renderedCellValue) === 0 ? (
        //     <Text size="12.5px" fw={500}>
        //       {Number(renderedCellValue)?.toLocaleString()} đ
        //     </Text>
        //   ) : (
        //     ""
        //   ),
      },
      { accessorKey: "lngTamTinh", header: "LNG tạm tính" },
      {
        accessorKey: "giaTmdt",
        header: "Giá TMDT",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "tinhTrangTmdt",
        header: "Tình trạng TMĐT",
      },
      { accessorKey: "moTaBh", header: "Mô tả bảo hành" },
      { accessorKey: "moTaKmWeb", header: "Mô tả KM Web", size: 500 },
      {
        accessorKey: "giaKoLayKm",
        header: "Giá không lấy KM",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "moTaKmPos",
        header: "Mô tả KM POS",
        size: 500,
      },
      {
        accessorKey: "giaThiTruong",
        header: "Giá thị trường",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} đ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "maLinhVuc",
        header: "Mã lĩnh vực",
        size: 135,
      },
      {
        accessorKey: "tenLinhVuc",
        header: "Tên lĩnh vực",
        size: 200,
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
        size: 135,
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
        size: 200,
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
        size: 135,
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
        size: 200,
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
        size: 135,
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
        size: 200,
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
        size: 135,
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
        size: 200,
      },
      {
        accessorKey: "maModel",
        header: "Mã model",
        size: 135,
      },
      {
        accessorKey: "tenModel",
        header: "Tên model",
        size: 200,
      },
      {
        accessorKey: "maHangSx",
        header: "Mã hãng sản xuất",
        size: 180,
      },
      {
        accessorKey: "tenHangSx",
        header: "Tên hãng sản xuất",
        size: 400,
      },
      {
        accessorKey: "coBanLe",
        header: "Có/Không bán lẻ",
      },
    ],
    [],
  );

  function getColorStatus(text: any) {
    switch (text) {
      case 1:
        return "teal";
      case 2:
        return "red";
      default:
        return "yellow";
    }
  }

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    setSearch((prevData: any) => ({
      ...prevData,
      [key]: value ? value : "",
    }));
  };

  const handleCleanKeySearch = (str: string) => {
    if (typeof str !== "string") {
      return "";
    }

    let cleaned = str.replace(/;+/g, ";").replace(/;\s*$/, "");
    return cleaned;
  };

  const filterDataByString = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c);

    const filteredData = dataCatSegment3c.filter((item) =>
      item.value?.includes(numbers),
    );

    return filteredData;
  };

  const sortData = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c)
      .split(";")
      .map((num) => num.trim());

    const matched = dataCatSegment3cFirst.filter((item) =>
      numbers.includes(item.value),
    );
    const unmatched = dataCatSegment3cFirst.filter(
      (item) => !numbers.includes(item.value),
    );

    const result = [...matched, ...unmatched];

    return result;
  };

  //Hãng sản xuất
  const renderMultiSelectOptionBrand: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataBrand.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  // Memoize the menu items
  const menuItems = useMemo(() => {
    if (dataItem.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">
              {searchItem.length > 0
                ? "Không tìm thấy dữ liệu !!!"
                : "Nhập mã vật tư để tìm kiếm !!!"}
            </Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataItem.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchItem
            ?.toUpperCase()
            .includes(item.code?.toUpperCase())
            ? searchItem
                .toUpperCase()
                .split(";")
                .filter((val) => val.trim() !== item.code.toUpperCase())
                .join(";")
            : searchItem === ""
              ? item.code
              : `${searchItem};${item.code}`;

          setSearchItem(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchItem.toUpperCase().includes(item.code?.toUpperCase()) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataItem, searchItem]);

  const menuCatSegment3c = useMemo(() => {
    if (dataCatSegment3c.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment3c.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment3c.includes(item.value)
            ? searchCatSegment3c
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment3c === ""
              ? item.value
              : `${searchCatSegment3c};${item.value}`;

          setSearchCatSegment3c(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment3c.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment3c, searchCatSegment3c]);

  const menuCatSegment4d = useMemo(() => {
    if (dataCatSegment4d.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment4d.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment4d.includes(item.value)
            ? searchCatSegment4d
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment4d === ""
              ? item.value
              : `${searchCatSegment4d};${item.value}`;

          setSearchCatSegment4d(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment4d.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment4d, searchCatSegment4d]);

  const menuCatSegment5e = useMemo(() => {
    if (dataCatSegment5e.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment5e.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment5e.includes(item.value)
            ? searchCatSegment5e
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment5e === ""
              ? item.value
              : `${searchCatSegment5e};${item.value}`;

          setSearchCatSegment5e(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment5e.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment5e, searchCatSegment5e]);

  const menuCatSegment6f = useMemo(() => {
    if (dataCatSegment6f.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment6f.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment6f.includes(item.value)
            ? searchCatSegment6f
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment6f === ""
              ? item.value
              : `${searchCatSegment6f};${item.value}`;

          setSearchCatSegment6f(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment6f.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment6f, searchCatSegment6f]);

  const fetchData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được lọc dữ liệu trong khoảng 1 tháng");
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (search.FromDate.length > 0) {
        url += `&FromDate=${search.FromDate}`;
      }

      if (search.ToDate.length > 0) {
        url += `&ToDate=${search.ToDate}`;
      }

      if (searchItem.length > 0) {
        const searchData = dataItem?.map(
          (item) => `&DsIdVt=${item?.value?.toUpperCase().trim()}`,
        );
        url += searchData.join("");
      }

      if (searchCatSegment3c.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment3c)
          ?.split(";")
          ?.map((item: any) => `&DsMaLoai=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment4d.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment4d)
          ?.split(";")
          ?.map((item: any) => `&DsMaChung=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment5e.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment5e)
          ?.split(";")
          ?.map((item: any) => `&DsMaNhom=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment6f.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment6f)
          ?.split(";")
          ?.map((item: any) => `&DsMaModel=${item?.trim()}`);
        url += searchData.join("");
      }

      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => {
            url += `&${key}=${encodeURIComponent(item)}`;
          });
        }
      });

      try {
        const response = await repositoryDelivery.get(
          `/api/v1/PriceListDetail/get-list-history${url}`,
        );
        if (response && response.success) {
          let result = response.data;
          setData(result);
          setRowCount(response.totalCount);
          setIsCallFirst(true);
          table.resetRowSelection();
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const handleExportData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    const maxAllowedDate2 = new Date(fromDate);
    maxAllowedDate2.setMonth(fromDate.getDay() + 10);

    if (toDate > maxAllowedDate2) {
      NotificationExtension.Fails(
        "Chỉ được phép lọc dữ liệu trong khoảng 10 ngày !",
      );
    } else if (
      dataItem.length === 0 &&
      searchCatSegment3c.length === 0 &&
      searchCatSegment4d.length === 0 &&
      searchCatSegment5e.length === 0 &&
      searchCatSegment6f.length === 0 &&
      toDate > maxAllowedDate
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập mã tìm kiếm 1 trong các tham số: mã vật tư, mã loại, mã chủng, mã nhóm, mã model hoặc các mã tìm kiếm không hợp lệ !",
      );
    } else {
      open(); // Hiển thị loading
      try {
        let url = `/api/v1/PriceListDetail/export-history?Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}`;

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch}`;
        }

        if (search.FromDate.length > 0) {
          url += `&FromDate=${search.FromDate}`;
        }

        if (search.ToDate.length > 0) {
          url += `&ToDate=${search.ToDate}`;
        }

        if (searchItem.length > 0) {
          const searchData = dataItem?.map(
            (item) => `&DsIdVt=${item?.value?.trim()}`,
          );
          url += searchData.join("");
        }

        if (searchCatSegment3c.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment3c)
            ?.split(";")
            ?.map((item: any) => `&DsMaLoai=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment4d.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment4d)
            ?.split(";")
            ?.map((item: any) => `&DsMaChung=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment5e.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment5e)
            ?.split(";")
            ?.map((item: any) => `&DsMaNhom=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment6f.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment6f)
            ?.split(";")
            ?.map((item: any) => `&DsMaModel=${item?.trim()}`);
          url += searchData.join("");
        }

        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => {
              url += `&${key}=${encodeURIComponent(item)}`;
            });
          }
        });

        const _url = BASE_API_DELIVERY + url;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "Lich_su_cap_nhat_bang_gia" + _name + ".xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error: any) {
        console.error("Error:", error);
        // Hiển thị thông báo lỗi
        NotificationExtension.Fails(
          error.message || "Đã xảy ra lỗi không xác định!",
        );
      } finally {
        close(); // Đóng loading
      }
    }
  };

  //Hãng sản xuất
  const getDataBrand = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmBrand/get-all",
    );

    if (res && res?.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.text !== null && item.att1 !== null)
        ?.map((item: any) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
        }));
      setDataBrand(dataAPI);
    }
  };

  //Mã vật tư
  const getDataItem = async () => {
    try {
      let url = "";

      if (
        handleCleanKeySearch(searchItem ?? "").length > 1 &&
        handleCleanKeySearch(searchItem ?? "")
          .trim()
          .includes(";")
      ) {
        const cleanKeySearch = handleCleanKeySearch(searchItem ?? "")
          ?.toUpperCase()
          ?.trim();

        url += `${cleanKeySearch
          ?.split(";")
          ?.map((item) => `&ListItemCode=${item.trim().replace(" ", "")}`)
          .join("")}`;
      } else if (
        handleCleanKeySearch(searchItem ?? "")?.includes(";") === false &&
        (searchItem ?? "")?.length > 0
      ) {
        url += `&ListItemCode=${searchItem?.toUpperCase()}`;
      }

      const response = await repositoryPos.get(
        `api/v1/TblItem/get-list?Skip=0&Take=100` + url,
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((item: any) => item.itemCode && item.itemName)
          .map((item: any) => ({
            label: item.itemCode + " - " + item.itemName,
            value: item.itemId?.toString(),
            code: item.itemCode,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItem(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Call API Loại
  const fetchCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment3c(dataAPI);
      setDataCatSegment3cFirst(dataAPI);
    }
  };

  //Call API Chủng
  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=30";

    if (searchCatSegment3c.length > 0) {
      const searchML = handleCleanKeySearch(searchCatSegment3c).split(";");

      searchML.forEach((item) => {
        url += `&listCodeSegmentString3=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      !searchCatSegment4d.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment4d}`;
    } else if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      searchCatSegment4d.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment4d)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  //Call API Nhóm
  const fetchCatSegment5e = async () => {
    let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=30";

    if (searchCatSegment4d.length > 0) {
      url += `&ListCodeString4=${handleCleanKeySearch(searchCatSegment4d)}`;
    }

    if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      !searchCatSegment5e.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment5e}`;
    } else if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      searchCatSegment5e.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment5e)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment5e(dataAPI);
    }
  };

  //Call API Model
  const fetchCatSegment6f = async () => {
    let url = "/api/v1/TblCatSegment6f/get-list?Skip=0&Take=30";

    if (searchCatSegment5e.length > 0) {
      const searchMN = handleCleanKeySearch(searchCatSegment5e).split(";");

      searchMN.forEach((item) => {
        url += `&listCodeSegmentString5=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      !searchCatSegment6f.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment6f}`;
    } else if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      searchCatSegment6f.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment6f)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment6f(dataAPI);
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([fetchCatSegment3c()]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
    };
    nextuse();
  }, []);

  useEffect(() => {
    if (debouncedItemCode.length > 0) {
      getDataItem();
    } else {
      setDataItem([]);
    }
  }, [debouncedItemCode]);

  useEffect(() => {
    if (debouncedCatSegment3c.length === 0) {
      setSearchCatSegment4d("");
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    if (!searchCatSegment3c?.includes(";") && searchCatSegment3c.length > 0) {
      setDataCatSegment3c(filterDataByString());
    } else if (searchCatSegment3c?.includes(";")) {
      setDataCatSegment3c(sortData());
    } else if (searchCatSegment3c.length === 0) {
      setDataCatSegment3c(dataCatSegment3cFirst);
    }

    fetchCatSegment4d();
  }, [debouncedCatSegment3c]);

  useEffect(() => {
    if (debouncedCatSegment4d.length === 0) {
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    fetchCatSegment4d();
    fetchCatSegment5e();
  }, [debouncedCatSegment4d]);

  useEffect(() => {
    if (debouncedCatSegment5e.length > 0) {
      setSearchCatSegment6f("");
    }

    fetchCatSegment6f();
    fetchCatSegment5e();
  }, [debouncedCatSegment5e]);

  useEffect(() => {
    fetchCatSegment6f();
  }, [debouncedCatSegment6f]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableBottomToolbar: true,
    enableRowNumbers: true,
    // manualPagination: true,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCt"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.so_Ct ?? undefined,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
        ref={headerRef}
      >
        <Group justify="space-between" mb={5}>
          <_breadcrumb></_breadcrumb>
          {/* Export Excel BE */}
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => {
              handleExportData();
            }}
          >
            Export Excel
          </Button>
        </Group>
        <Grid>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={search.FromDate ? new Date(search.FromDate) : null}
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "FromDate",
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={search.ToDate ? new Date(search.ToDate) : null}
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "ToDate",
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã vật tư"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchItem("")}
                        style={{
                          display: searchItem.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchItem}
                    onChange={(e) => {
                      setSearchItem(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataItem.length <= 1
                        ? 32
                        : dataItem.length === 2
                          ? 64
                          : dataItem.length === 3
                            ? 96
                            : dataItem.length === 4
                              ? 128
                              : dataItem.length === 5
                                ? 160
                                : dataItem.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuItems}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã loại"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => {
                          setSearchCatSegment3c("");
                          setDataCatSegment3c(dataCatSegment3cFirst);
                        }}
                        style={{
                          display:
                            searchCatSegment3c.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment3c}
                    onChange={(e) => {
                      setSearchCatSegment3c(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment3c.length <= 1
                        ? 32
                        : dataCatSegment3c.length === 2
                          ? 64
                          : dataCatSegment3c.length === 3
                            ? 96
                            : dataCatSegment3c.length === 4
                              ? 128
                              : dataCatSegment3c.length === 5
                                ? 160
                                : dataCatSegment3c.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment3c}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã chủng"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment4d("")}
                        style={{
                          display:
                            searchCatSegment4d.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment4d}
                    onClick={() => {
                      if (dataCatSegment4d.length === 0) {
                        fetchCatSegment4d();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment4d(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment4d.length <= 1
                        ? 32
                        : dataCatSegment4d.length === 2
                          ? 64
                          : dataCatSegment4d.length === 3
                            ? 96
                            : dataCatSegment4d.length === 4
                              ? 128
                              : dataCatSegment4d.length === 5
                                ? 160
                                : dataCatSegment4d.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment4d}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã nhóm"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment5e("")}
                        style={{
                          display:
                            searchCatSegment5e.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment5e}
                    onClick={() => {
                      if (dataCatSegment5e.length === 0) {
                        fetchCatSegment5e();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment5e(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment5e.length <= 1
                        ? 32
                        : dataCatSegment5e.length === 2
                          ? 64
                          : dataCatSegment5e.length === 3
                            ? 96
                            : dataCatSegment5e.length === 4
                              ? 128
                              : dataCatSegment5e.length === 5
                                ? 160
                                : dataCatSegment5e.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment5e}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã model"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment6f("")}
                        style={{
                          display:
                            searchCatSegment6f.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment6f}
                    onClick={() => {
                      if (dataCatSegment6f.length === 0) {
                        fetchCatSegment6f();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment6f(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment6f.length <= 1
                        ? 32
                        : dataCatSegment6f.length === 2
                          ? 64
                          : dataCatSegment6f.length === 3
                            ? 96
                            : dataCatSegment6f.length === 4
                              ? 128
                              : dataCatSegment6f.length === 5
                                ? 160
                                : dataCatSegment6f.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment6f}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã hãng sản xuất"
              clearable
              searchable
              data={dataBrand}
              value={search.DsMaHangSx}
              renderOption={renderMultiSelectOptionBrand}
              leftSection={<IconTrademark size={20} color="#15aabf" />}
              onClick={() => {
                if (dataBrand.length === 0) {
                  getDataBrand();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "DsMaHangSx");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default PriceListUpdateHistory;
